import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../../constants/common'
import { NOTIFICATION_REQUIRED_FIELDS } from '../../../../constants/notification'

export function useFormRequiredNotification({
  entityActionError,
  hasEmptyRequired,
  removeNotification,
  setNotification,
  submitCount,
}) {
  const { t } = useTranslation()

  useEffect(() => {
    if (hasEmptyRequired && (submitCount > 0 || !isFinite(submitCount))) {
      setNotification?.({
        id: NOTIFICATION_REQUIRED_FIELDS,
        text: entityActionError
          ? t('Error.EntityActionErrorKey')
          : t('Error.RequiredFieldsErrorKey'),
        type: NOTIFICATION_TYPE.error,
      })
    } else {
      removeNotification(NOTIFICATION_REQUIRED_FIELDS)
    }
  }, [hasEmptyRequired, submitCount])
}
